/**
 * 授权信息
 *
 */
export const useAuthorityStore = defineStore('authority', () => {
  // state
  // 登录信息对象
  const loginInfo = ref({});
  // 是否登录标记
  const isLogin = computed(() => {
    return !!loginInfo.value?.id;
  });
  // 用户资料（主要用于移动端传值）
  const userProfile = ref({});
  // 功能列表
  const functionList = ref([]);
  // 原始的菜单列表
  const originalFunctionList = ref([]);
  // 个人功能列表
  const personalFunctionList = ref([]);
  // 页面功能对象
  const pageFunctionObj = ref({});
  // 权限编码列表
  const authorityCodeList = ref([]);
  // 菜单编码
  const menuUrl = ref('');
  // 用户类型
  const userType = ref(null);
  // 终端（默认值为1）
  const terminal = ref(1);
  // 认证方式（1:登录名+密码，2:手机号+密码，3:邮箱+密码，4:微信，5:手机号+验证码），默认值为1
  const authenticationType = ref(1);
  // 默认页面对象
  const defaultPage = ref({});
  // 认证令牌对象
  const authToken = ref({});
  // 临时有效的令牌活动时间，默认值为0
  const authTokenActivityTimeout = ref(0);
  // 令牌有效期，默认值为0
  const authTokenTimeout = ref(0);
  // 路由表
  const routes = ref([]);
  const corpId = ref('');

  // 个人中心菜单列表
  const personalMenuCodes = ref([
    'M010002',
    'M020013',
    'M020012',
    'M020011',
    'M020057',
    'M020058',
  ]);

  // 方法

  /**
   * 设置路由
   *
   * @param payload 路由数据
   * @returns 无
   */
  function setRouters(payload) {
    routes.value = payload;
  }

  /**
   * 设置登录信息
   *
   * @param loginInfos 登录信息对象
   */
  function setLoginInfo(loginInfos) {
    loginInfo.value = loginInfos;
  }

  /**
   * 查找页面函数
   *
   * @param func 页面函数对象
   * @returns 返回包含所有页面函数的数组
   */
  function findPageFunctions(func) {
    if (func.Children.length === 0) {
      return [func];
    }
    let funcArray = [];
    if (func.Children.length > 0) {
      funcArray = func.Children.reduce((accumulator, childFunc) => {
        return accumulator.concat(findPageFunctions(childFunc));
      }, funcArray);
    }
    return funcArray;
  }

  /**
   * 设置函数
   *
   * @param payload 包含函数列表等信息的对象
   * @param payload.functionList 函数列表
   * @param payload.originalFunctionList 原始函数列表
   * @param payload.authorityCodeList 权限编码列表
   * @param payload.personalFunctionList 个人函数列表
   * @returns 无返回值
   */
  function setFunction(payload) {
    functionList.value = payload.functionList;
    originalFunctionList.value = payload.originalFunctionList;
    authorityCodeList.value = payload.authorityCodeList;
    personalFunctionList.value = payload.personalFunctionList;

    pageFunctionObj.value = {};
    if (payload.functionList) {
      payload.functionList.forEach((funcItem) => {
        const pageFuncs = findPageFunctions(funcItem);
        pageFuncs.forEach((praPageFunc) => {
          const pageFunc = { ...praPageFunc };
          // 替换真正的路由路径
          const route = routes.value.find(
            (routeItem) => routeItem.name === pageFunc.menuCode,
          );
          if (route) {
            pageFunc.menuUrl = route.path;
          }
          pageFunctionObj.value[pageFunc.menuUrl] = pageFunc;
        });
      });
    }
  }

  /**
   * 设置登录信息以及相关函数
   *
   * @param payload 包含登录信息以及相关函数的对象
   * @param payload.loginInfo 登录信息
   * @param payload.originalFunctionList 原始函数列表
   * @param payload.authorityCodeList 权限编码列表
   * @param payload.functionList 功能列表
   * @param payload.personalFunctionList 个人功能列表
   * @returns 无返回值
   */
  function setLoginInfoAndFunction(payload) {
    // 设置登录人信息
    loginInfo.value = payload.loginInfo;
    // 设置权限信息系
    setFunction(payload);
  }

  /**
   * 设置认证令牌
   *
   * @param token 认证令牌对象
   * @param token.activityTimeout 令牌活动超时时间，单位为毫秒
   * @param token.timeout 令牌超时时间，单位为毫秒
   */
  function setAuthToken(token) {
    authToken.value = token;
    authTokenActivityTimeout.value = token.activityTimeout;
    authTokenTimeout.value = token.timeout;
  }

  /**
   * 设置菜单编码
   *
   * @param url 菜单编码
   */
  function setMenuUrl(url) {
    menuUrl.value = url;
  }

  /**
   * 设置用户类型
   *
   * @param type 用户类型
   * @returns 无返回值
   */
  function setUserType(type) {
    userType.value = type;
  }

  /**
   * 设置终端类型
   *
   * @param type 终端类型
   */
  function setTerminal(type) {
    terminal.value = type;
  }

  /**
   * 设置认证方式
   *
   * @param type 认证方式类型
   */
  function setAuthenticationType(type) {
    authenticationType.value = type;
  }

  /**
   * 设置默认页面
   *
   * @param page 页面名称
   */
  function setDefaultPage(page) {
    defaultPage.value = page;
  }

  function setCorpId(val) {
    corpId.value = val;
  }

  return {
    loginInfo,
    isLogin,
    userProfile,
    functionList,
    personalFunctionList,
    originalFunctionList,
    authorityCodeList,
    pageFunctionObj,
    menuUrl,
    userType,
    defaultPage,
    terminal,
    authenticationType,
    authToken,
    authTokenActivityTimeout,
    authTokenTimeout,
    routes,
    personalMenuCodes,
    setRouters,
    setLoginInfo,
    setLoginInfoAndFunction,
    setMenuUrl,
    setUserType,
    setTerminal,
    setAuthenticationType,
    setFunction,
    setDefaultPage,
    setAuthToken,
    corpId,
    setCorpId,
  };
});
